import { useEffect, useState, useCallback } from 'react'

import { onSnapshot, collection } from 'firebase/firestore'

import { firestore } from '../firebase/firebaseConfig'
import {
  createStudent,
  getStudent,
  saveStudent,
  upsertLog,
} from '../services/studentService'
import { Student, NewLog } from '../types'

export function useStudents() {
  const [students, setStudents] = useState<Student[]>([])
  const [activeStudent, setActiveStudent] = useState<Student | null>(null)

  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(firestore, 'students'),
      (snapshot) => {
        setStudents(snapshot.docs.map((doc) => doc.data() as Student))
      },
    )
    return () => unsubscribe()
  }, [])

  const handleCreate = useCallback(
    (student: Student) => createStudent(student),
    [],
  )
  const handleSave = useCallback((student: Student) => saveStudent(student), [])
  const handleGet = useCallback((id: string) => getStudent(id), [])
  const handleUpsertLog = useCallback(
    (id: string, log: NewLog, cuponId: string | null) =>
      upsertLog(id, log, cuponId),
    [],
  )

  return {
    students,
    activeStudent,
    setActiveStudent,
    createStudent: handleCreate,
    saveStudent: handleSave,
    fetchStudent: handleGet,
    upsertLog: handleUpsertLog,
  }
}
